const validTime = (value) => /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
const identifiers = (employee) => [employee?.id, employee?.uid, employee?.userId, employee?.employeeId, employee?.email].filter(Boolean).map(String);

export function reusableShifts(shifts, projects, employee = null) {
  const ids = new Set(identifiers(employee));
  const grouped = new Map();
  shifts.forEach((shift) => {
    const assigned = [shift.employeeId, shift.userId, shift.assignedEmployeeId, ...(Array.isArray(shift.employees) ? shift.employees.flatMap(identifiers) : [])].filter(Boolean).map(String);
    if (employee && !assigned.some((id) => ids.has(id))) return;
    const project = projects.find((item) => item.id === shift.projectId) || (!shift.projectId && projects.find((item) => item.name === shift.project));
    if (!project) return;
    const times = String(shift.time || "").split(/\s*[-–]\s*/);
    const startTime = String(shift.startTime || times[0] || "").trim();
    const endTime = String(shift.endTime || times[1] || "").trim();
    if (!validTime(startTime) || !validTime(endTime) || startTime === endTime) return;
    const key = JSON.stringify([project.id, startTime, endTime]);
    const existing = grouped.get(key);
    const lastUsed = typeof shift.date === "string" ? shift.date : shift.date?.toDate?.().toISOString().slice(0, 10) || "";
    grouped.set(key, { key, id: project.id, name: project.name, startTime, endTime, count: (existing?.count || 0) + 1, lastUsed: lastUsed > (existing?.lastUsed || "") ? lastUsed : existing?.lastUsed || "" });
  });
  return [...grouped.values()].sort((a, b) => b.count - a.count || b.lastUsed.localeCompare(a.lastUsed) || a.name.localeCompare(b.name, "sv"));
}
